// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emoji-btn {
  padding: 8px;
}
.emoji-btn .button {
  height: 34px;
  color: #7a7a7a;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 0;
}
.emoji-btn .button:active {
  border-color: transparent;
}
.emoji-btn .button:focus {
  border-color: transparent;
}
.emoji-btn .dropdown-menu {
  min-width: 14em;
}
.emoji-btn .dropdown-menu .dropdown-content {
  height: 24em;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
}
.emoji-btn .dropdown-menu .dropdown-content .dropdown-menu {
  position: absolute;
  top: 10px;
  bottom: 0px;
  left: 0px;
  right: -20px;
  overflow: auto;
}

.emoji-mart-category .emoji-mart-emoji span:hover {
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/app/emojimart/emojimart.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EACE,yBAAA;AAGN;AACE;EACE,eAAA;AACJ;AAAI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAEN;AADM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;AAGR;;AAGA;EACE,0BAAA;AAAF","sourcesContent":[".emoji-btn{\n  padding: 8px;\n  .button{\n    height: 34px;\n    color: #7a7a7a;\n    padding-left: 6px;\n    padding-right: 6px;\n    border-radius: 0;\n    &:active{\n      border-color: transparent;\n    }\n    &:focus{\n      border-color: transparent;\n    }\n  }\n\n  .dropdown-menu{\n    min-width: 14em;\n    .dropdown-content{\n      height: 24em;\n      width: 100%;\n      overflow: hidden;\n      position: relative;\n      border-radius: 6px;\n      .dropdown-menu{\n        position: absolute;\n        top:10px;\n        bottom: 0px;\n        left:0px;\n        right:-20px;\n        overflow: auto;\n      }\n    }\n  }\n}\n\n.emoji-mart-category .emoji-mart-emoji span:hover{\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
